function updateSidebar(state, action, actionType) {
  switch (action.type) {
    case actionType:
      return Object.assign({}, state, {
        items: action.data
      });
    default:
      return state;
  }
}

export const sidebarNav = (state = [], action) => {
  return updateSidebar(state, action, 'SIDEBAR')
}